import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h1>Not found</h1>
            <h4>404</h4>
        </div>
    );
};

export default Notfound;